import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import styles from './group.module.css';

interface Props {
  loading: boolean;
  loadMore: () => void;
}

export const ShowMore: FC<Props> = ({ loading, loadMore }) => {
  const fetchingText = useTranslation('notifications.messages.loading');
  const showMoreText = useTranslation('notifications.commands.show_more');

  return (
    <Button
      className={styles.more}
      size="small"
      type="link"
      disabled={loading}
      loading={loading}
      onClick={(e) => {
        e.stopPropagation();
        loadMore();
      }}
    >
      {loading ? fetchingText : showMoreText}
    </Button>
  );
};
